// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

import { layoutTokens } from "./css-refs.layout-tokens.ts";

/** Modal dimension tokens */
export const modal = layoutTokens.modal;

/** Sidebar dimension tokens */
export const sidebar = layoutTokens.sidebar;

/** Content max-width tokens */
export const contentMaxWidth = layoutTokens.contentMaxWidth;

/** Percent-of-parent proportion tokens */
export const proportion = layoutTokens.proportion;

/** Touch target dimension tokens */
export const touchTargets = layoutTokens.touchTargets;

/** Divider dimension tokens */
export const divider = layoutTokens.divider;

/** List dimension tokens */
export const list = layoutTokens.list;

/** Viewport dimension tokens */
export const viewport = layoutTokens.viewport;
